import React from "react";

export const TabContext = React.createContext({
  registerTab: () => ({}),
  setActiveTabId: () => ({}),
  tabList: [],
  activeTabId: "",
});